import { render, staticRenderFns } from "./inputDateFlatPickr.global.vue?vue&type=template&id=487fba5a&lang=pug&"
import script from "./inputDateFlatPickr.global.vue?vue&type=script&lang=ts&"
export * from "./inputDateFlatPickr.global.vue?vue&type=script&lang=ts&"
import style0 from "./inputDateFlatPickr.global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports